<template>
  <!-- banner -->
  <section class="banner-section">
    <img class="img-fluid d-none d-lg-flex banner-bg1" src="@/assets/img/bg/bg-15.png" alt="img" />
    <img class="img-fluid d-none d-lg-flex banner-bg2" src="@/assets/img/bg/bg-16.png" alt="img" />
    <img class="img-fluid d-none d-lg-flex banner-bg3" src="@/assets/img/bg/bg-17.png" alt="img" />
    <img class="img-fluid d-none d-lg-flex banner-bg4" src="@/assets/img/bg/bg-18.png" alt="img" />
    <div class="container">
      <div class="row align-items-center justify-content-between">
        <div class="col-xl-7 col-lg-7">
          <div class="banner-content pe-xxl-5">
            <span class="hero-title">Sapta Learning Center</span>
            <h1 class="mb-4 text-white">
              Akselerasi Keahlian <span>Teknis</span> Anda di <span>Sapta</span> Learning Center
            </h1>
            <p class="fs-lg text-center text-md-start pb-2 pb-md-3 mb-4">
              Platform pelatihan mandiri untuk mendukung profesionalisme dan performa kerja karyawan PT Sapta Tunas
              Teknologi.
            </p>


            <div class="d-flex align-items-center gap-4 justify-content-lg-between justify-content-center flex-wrap">
              <div class="counter-item">
                <div class="counter-icon flex-shrink-0">
                  <img src="@/assets/img/icons/icon-32.svg" alt="img" />
                </div>
                <div class="count-content">
                  <h5 class="text-purple">
                    <span class="count-digit"><vue3-autocounter class="counter" ref="counter" :startAmount="0"
                        :delay="3" :endAmount="100" :duration="5" :autoinit="true" /></span>+
                  </h5>
                  <p>Modul Teknis</p>
                </div>
              </div>
              <div class="counter-item">
                <div class="counter-icon flex-shrink-0">
                  <img src="@/assets/img/icons/icon-33.svg" alt="img" />
                </div>
                <div class="count-content">
                  <h5 class="text-skyblue">
                    <span class="count-digit"><vue3-autocounter class="counter" ref="counter" :startAmount="0"
                        :delay="3" :endAmount="500" :duration="5" :autoinit="true" /></span>+
                  </h5>
                  <p>Karyawan Terlatih</p>
                </div>
              </div>
              <div class="counter-item">
                <div class="counter-icon flex-shrink-0">
                  <img src="@/assets/img/icons/icon-34.svg" alt="img" />
                </div>
                <div class="count-content">
                  <h5 class="text-success">
                    <span class="count-digit"><vue3-autocounter class="counter" ref="counter" :startAmount="0"
                        :delay="3" :endAmount="95" :duration="5" :autoinit="true" /></span>%
                  </h5>
                  <p>Tingkat Kelulusan</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-4 col-lg-5">
          <div class="banner-image">
            <div class="swiper swiper-slider-banner" ref="swiperContainer">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="slide in limitedCourses" :key="slide.course_id">
                  <div class="course-item-two course-item mb-0">
                    <div class="course-img">
                      <img
                        :src="courseThumbnail(slide)"
                        alt="Course image"
                        class="img-fluid"
                        @error="onThumbnailError"
                      />
                    </div>

                    <div class="course-content">
                      <div class="d-flex justify-content-between mb-2">
                        <div class="d-flex align-items-center">
                          <a href="#" class="avatar avatar-sm">
                            <img :src="authStore.currentUser
                              ? `${authStore.authUrl}/storage/photo/${authStore.userPhoto(slide.instructor)}`
                              : require('@/assets/img/user/img-user.png')" alt="img" class="img-fluid" />
                          </a>
                          <div class="ms-2">
                            <a href="#" class="link-default fs-14">{{ userStore.userName(slide.instructor) }}</a>
                          </div>
                        </div>
                      </div>

                      <h6 class="mb-3">
                        <router-link :to="{
                          name: 'CourseDetail',
                          params: { course_id: slide.course_id },
                        }">{{
                          slide.title
                        }}</router-link>
                      </h6>

                      <div class="d-flex align-items-center justify-content-between">
                        <router-link :to="{
                          name: 'CourseDetail',
                          params: { course_id: slide.course_id },
                        }" class="btn btn-dark w-100 btn-sm d-inline-flex justify-content-center">
                          Mulai Pelatihan
                          <i class="isax isax-arrow-right-3 ms-1"></i>
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- banner -->
</template>

<script>
import { ref, computed, watch, onMounted, onBeforeUnmount, nextTick } from "vue";
import Swiper from "swiper";
import { EffectCards } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-cards";
import { useCourseFetchStore } from "@/stores/course/course-fetch-store.js";
import { useUserStore } from "@/stores/user/user-store.js";
import { useAuthStore } from "@/stores/auth-store";

const FALLBACK_THUMBNAIL = require("@/assets/img/fallback_image.jpg");

export default {
  setup() {
    const swiperContainer = ref(null);
    let swiperInstance = null;

    const courseFetchStore = useCourseFetchStore();
    const userStore = useUserStore();
    const authStore = useAuthStore();

    const limitedCourses = computed(() =>
      (courseFetchStore.paginatedCourses || []).slice(0, 5)
    );

    const courseThumbnail = (slide) => {
      if (!slide?.thumbnail) return FALLBACK_THUMBNAIL;
      return `${authStore.Url}/media/${slide.thumbnail}`;
    };

    const onThumbnailError = (event) => {
      event.target.src = FALLBACK_THUMBNAIL;
    };

    const destroySwiper = () => {
      if (swiperInstance) {
        swiperInstance.destroy(true, true);
        swiperInstance = null;
      }
    };

    const initSwiper = async () => {
      await nextTick();
      if (!swiperContainer.value || limitedCourses.value.length === 0) return;

      destroySwiper();

      swiperInstance = new Swiper(swiperContainer.value, {
        modules: [EffectCards],
        effect: "cards",
        grabCursor: true,
        loop: limitedCourses.value.length > 2,
        cardsEffect: {
          slideShadows: false,
          perSlideOffset: 15,
          perSlideRotate: 2,
        },
      });
    };

    watch(limitedCourses, () => {
      initSwiper();
    });

    onMounted(() => {
      courseFetchStore.fetchCourseList();
      userStore.fetchTeachers();
      userStore.fetchPrincipals();
      initSwiper();
    });

    onBeforeUnmount(() => {
      destroySwiper();
    });

    return {
      courseFetchStore,
      userStore,
      authStore,
      swiperContainer,
      limitedCourses,
      courseThumbnail,
      onThumbnailError,
    };
  },
};
</script>
